module.exports = __webpack_public_path__ + "static/sec2-9934cb24303f8b9187ff60c8c5721a3f.png";